import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { MaterialModule } from '../material/material.module';

// Directives
import {     
  NativeElementInjectorDirective,
  FormSubmitDirective,  
  MatMsgDirective,
  DisableControlDirective,
  FontResizeDirective,
  ResponsiveGaugeDirective
} from './directives';

import {
  ConfirmDialogComponent,
  SelectorDialogComponent
} from './components/dialogs';

import { 
  ControlErrorComponent, 
  DynamicTextComponent, 
  FormPageComponent,   
  ValidationMessagesComponent,
  FormValidationMessagesComponent,
  ToggleButtonComponent,
  LoaderComponent,
  CardComponent,
  ReadOnlyFieldComponent,
  DynamicListItemComponent,  
  SearchComponent,
  InputAutocompleteComponent,
  AngularFileUploaderComponent,
  SearchSimpleComponent,
  StepIndicatorComponent,
} from './components';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    NativeElementInjectorDirective,
    FormSubmitDirective,    
    MatMsgDirective,
    DisableControlDirective,
    FontResizeDirective,
    ResponsiveGaugeDirective,

    ControlErrorComponent,
    ValidationMessagesComponent,
    FormValidationMessagesComponent,
    FormPageComponent,
    DynamicTextComponent,
    ToggleButtonComponent,
    LoaderComponent,    
    CardComponent,    
    ReadOnlyFieldComponent, 
    DynamicListItemComponent,
    SearchComponent,
    InputAutocompleteComponent,
    ConfirmDialogComponent,
    SelectorDialogComponent,
    AngularFileUploaderComponent,
    SearchSimpleComponent,
    StepIndicatorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,   
    MaterialModule,    
    FormsModule,
    TranslateModule,
  ],
  providers: [],
  exports: [
    MaterialModule,
    TranslateModule,

    NativeElementInjectorDirective,
    FormSubmitDirective,
    MatMsgDirective,
    DisableControlDirective,
    FontResizeDirective, 
    ResponsiveGaugeDirective,

    ControlErrorComponent,
    ValidationMessagesComponent,
    FormValidationMessagesComponent,
    FormPageComponent,
    DynamicTextComponent,
    ToggleButtonComponent,
    LoaderComponent,
    CardComponent,    
    ReadOnlyFieldComponent,
    DynamicListItemComponent,
    SearchComponent,
    SearchSimpleComponent,
    InputAutocompleteComponent,
    ConfirmDialogComponent,
    AngularFileUploaderComponent,
    StepIndicatorComponent
  ]
})
export class SharedModule {

}
